import axios, { CancelTokenSource } from 'axios';
import { postWhenAuthorized } from './api';

export interface IUpcommingMeetingsRequest {
    startDate?: string
    endDate?: string
    searchPhrase: string;
}

export const upcommingMeetings = async (request: IUpcommingMeetingsRequest, cancelTokenSource: CancelTokenSource = axios.CancelToken.source()) => await postWhenAuthorized(() => `/api/tools/meetings/upcomming`, request, cancelTokenSource);
